import { connect } from 'react-redux';
import PermissionsShowView from './permissions_show_view';

const PermissionsShowContainer = connect()(PermissionsShowView);

export default PermissionsShowContainer;
